var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activeLayer)?_c('div',{staticClass:"card legend-container position-absolute"},[_c('div',{staticClass:"card-body text-left"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.activeLayer.label,"alt":""}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }